module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "fr01"
    }
  }, [_c('h2', {
    staticClass: "center2"
  }, [_vm._v("Also by Alexander Mikaberidze")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lion of the Russian Army:")])]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Life and Career of General Peter Bagration")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72c3ade8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_fr01.vue
// module id = 57
// module chunks = 0